import React from 'react';
import PropTypes from 'prop-types';
const Revoke = ({
  onClick,
  children
}) => /*#__PURE__*/React.createElement("div", {
  onClick: onClick,
  className: "revoke revoke--active"
}, /*#__PURE__*/React.createElement("div", {
  className: "revoke__background"
}), /*#__PURE__*/React.createElement("p", null, children));
Revoke.propTypes = {
  /** Функция нажатия на компонент */onClick: PropTypes.func.isRequired,
  children: PropTypes.node
};
export default Revoke;